import { useState } from "react"
import { Outlet, useLocation } from "react-router"
import Header from "../../component/shared/Header"
import Sidebar from "../../component/shared/Sidebar"
import Footer from "../../component/shared/Footer"

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const activeTab = useLocation().pathname

  return (
    <div className={isSidebarOpen ? "" : "toggle-sidebar"}>
      <Header toggleSidebar={toggleSidebar} activeTab={activeTab} />
      <Sidebar activeTab={activeTab} />
      <Outlet />
      <Footer activeTab={activeTab} />
    </div>
  )
}

export default AdminLayout
